/* ==========================================================================
   Theoric - MOTOR DE PROMOCOES

   Substitui assets/theoric-cart-brinde.js, que sabia UMA promocao de cor (o
   Micellar Milk). Este arquivo nao sabe nenhuma: le todas de
   window.THEORIC_PROMOS (snippets/theoric-promocoes-config.liquid, alimentado
   pelo metacampo da loja theoric.promocoes) e obedece.

   >>> AS DUAS NATUREZAS, E POR QUE O CODIGO AS TRATA DIFERENTE <<<

   Tanto "bonificacao" quanto "brinde" sao somente visuais no carrinho.
   Nenhum premio vira linha, vai ao checkout ou interfere em cupons. O motor
   grava os premios elegiveis no atributo _theoric_brindes; apos o pagamento,
   a integracao usa esse contrato para incluir a bonificacao no ERP.

   >>> REGRA DE OURO (herdada do nucleo) <<<
   Nada aqui chama /cart.js por conta propria fora do necessario, e nada manda
   `sections` num POST. Quem manda no estado e TheoricCart.

   API publica (para botoes no tema):
     TheoricPromos.estado()               -> diagnostico das promos
     TheoricPromos.adicionar(id)          -> aceita uma promo nao automatica
     TheoricPromos.remover(id)            -> recusa/remove
     TheoricPromos.escolher(id, handle)   -> troca a opcao premiada
   ========================================================================== */
(function () {
  'use strict';

  if (window.TheoricPromos) return;

  var T = window.TheoricCart;
  var CFG = window.THEORIC_PROMOS;
  if (!T || !CFG) return;

  var ATRIBUTO_BRINDES = '_theoric_brindes';
  var ATRIBUTO_OPTIN = '_theoric_promo_optin';
  var ATRIBUTO_ESCOLHAS = '_theoric_promo_escolhas';
  var CUPOM_PRIMEIRA_COMPRA = '__primeira_compra_com_cupom__';
  /* Gravado por assets/theoric-form-brinde.js quando um formulario e enviado.
     O formato e o nome precisam andar juntos nos dois arquivos. */
  var COOKIE_BRINDE = 'theoric_brinde_form';

  var processando = false;
  var metaCache = null;
  var metaChave = null;
  var linhaJaVista = {};      // ver "recusa implicita", em aceita()
  var ultimoEstado = { promocoes: [] };

  /* ======================================================================
     LEITURA DA CONFIGURACAO
     ====================================================================== */

  function agoraDentroDaJanela(promo) {
    var agora = Date.now();
    if (promo.inicio) {
      var ini = Date.parse(promo.inicio);
      if (!isNaN(ini) && agora < ini) return false;
    }
    if (promo.fim) {
      var fim = Date.parse(promo.fim);
      if (!isNaN(fim) && agora > fim) return false;
    }
    return true;
  }

  function promosAtivas() {
    return (CFG.promocoes || []).filter(function (promo) {
      if (!promo || !promo.id) return false;
      if (promo.ativo === false) return false;
      return agoraDentroDaJanela(promo);
    });
  }

  function produtoDe(handle) {
    return (CFG.produtos || {})[handle] || null;
  }

  /* Handles que a promo pode premiar: o principal e as alternativas. */
  function handlesDaPromo(promo) {
    var premio = promo.premio || {};
    var lista = [];
    if (premio.handle) lista.push(premio.handle);
    (premio.opcoes || []).forEach(function (h) {
      if (h && lista.indexOf(h) === -1) lista.push(h);
    });
    return lista.filter(function (h) {
      var p = produtoDe(h);
      return p && p.variant_id;
    });
  }

  /* ======================================================================
     ESTADO DO CARRINHO
     ====================================================================== */

  function props(item) {
    return (item && item.properties) || {};
  }

  function eRecompensa(item) {
    return props(item)._brinde === 'true';
  }

  function promoDaLinha(item) {
    return props(item)._promo_id || '';
  }

  function itensReais(carrinho) {
    return ((carrinho && carrinho.items) || []).filter(function (item) {
      return !eRecompensa(item);
    });
  }

  function atributos(carrinho) {
    return (carrinho && carrinho.attributes) || {};
  }

  function listaDoAtributo(carrinho, chave) {
    var bruto = atributos(carrinho)[chave];
    if (!bruto) return [];
    return String(bruto).split(',').map(function (v) { return v.trim(); })
      .filter(Boolean);
  }

  function mapaDoAtributo(carrinho, chave) {
    var bruto = atributos(carrinho)[chave];
    var mapa = {};
    if (!bruto) return mapa;
    String(bruto).split(',').forEach(function (par) {
      var partes = par.split(':');
      if (partes.length === 2) mapa[partes[0].trim()] = partes[1].trim();
    });
    return mapa;
  }

  /* ======================================================================
     METADADOS DAS LINHAS (tags e colecoes)

     /cart.js nao devolve tags nem colecoes do produto - so o Liquid enxerga.
     sections/theoric-cart-meta.liquid expoe as duas coisas, na MESMA ordem de
     cart.items. A busca so acontece quando alguma regra ativa precisa: uma
     promocao por quantidade ou valor nao paga esse pedagio.
     ====================================================================== */

  function precisaDeMeta(promos) {
    return promos.some(function (promo) {
      var regras = (promo.condicao && promo.condicao.regras) || [];
      return regras.some(function (r) {
        /* Quantidade tambem precisa dos metadados: uma unidade de kit conta
           como a quantidade de produtos que existe dentro dele. */
        return r.tipo === 'tag' || r.tipo === 'colecao' ||
          r.tipo === 'quantidade_minima';
      });
    });
  }

  function chaveDoCarrinho(carrinho) {
    return ((carrinho && carrinho.items) || []).map(function (i) {
      return i.variant_id + 'x' + i.quantity;
    }).join('|');
  }

  function buscarMeta(carrinho) {
    var chave = chaveDoCarrinho(carrinho);
    if (metaCache && metaChave === chave) return Promise.resolve(metaCache);

    return fetch('/?section_id=theoric-cart-meta')
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector('[data-theoric-cart-meta]');
        if (!el) throw new Error('secao theoric-cart-meta nao encontrada');
        metaCache = JSON.parse(el.textContent);
        metaChave = chave;
        return metaCache;
      });
  }

  /* ======================================================================
     AVALIACAO DAS REGRAS
     ====================================================================== */

  function normalizar(txt) {
    return String(txt == null ? '' : txt).trim().toLowerCase();
  }

  function quantidadeReal(carrinho, meta) {
    var linhas = (carrinho && carrinho.items) || [];
    return linhas.reduce(function (soma, item, indice) {
      if (eRecompensa(item)) return soma;

      var m = (meta && meta[indice]) || {};
      var itensPorUnidade = m.kit === true
        ? Math.max(2, Number(m.kit_component_count || 0))
        : 1;

      return soma + (Number(item.quantity || 0) * itensPorUnidade);
    }, 0);
  }

  function subtotalReal(carrinho) {
    return itensReais(carrinho).reduce(function (soma, item) {
      return soma + Number(item.final_line_price || item.line_price || 0);
    }, 0);
  }

  function cuponsDoCarrinho(carrinho) {
    return T.cuponsAtivos(carrinho).map(function (d) {
      return normalizar(d.title);
    });
  }

  function candidataPrimeiraCompra() {
    var verificador = window.TheoricFirstPurchaseDiscount;
    return !!(verificador &&
      typeof verificador.isFirstPurchaseCandidate === 'function' &&
      verificador.isFirstPurchaseCandidate());
  }

  /* ======================================================================
     TAGS DA CLIENTE (regra tag_cliente)

     Duas fontes, e basta uma:
     - a conta logada: o Liquid publica as tags que alguma promocao exige;
     - o cookie do formulario: quem respondeu neste navegador ve o brinde
       mesmo deslogada, ou antes de o n8n terminar de marcar a conta.
     O cookie e so VISUAL. Quem decide se o brinde sai e a integracao, que
     confere a tag no e-mail do pedido.
     ====================================================================== */

  function lerCookieBrinde() {
    try {
      var prefixo = COOKIE_BRINDE + '=';
      var par = String(document.cookie || '').split(/;\s*/).filter(function (c) {
        return c.indexOf(prefixo) === 0;
      })[0];
      if (!par) return [];
      var dados = JSON.parse(decodeURIComponent(par.slice(prefixo.length)));
      var agora = Date.now();
      return ((dados && dados.itens) || []).filter(function (i) {
        return i && i.tag && !(i.expira && Date.parse(i.expira) < agora);
      });
    } catch (e) {
      return [];
    }
  }

  function gravarCookieBrinde(itens) {
    try {
      if (!itens.length) {
        document.cookie = COOKIE_BRINDE + '=; path=/; max-age=0; SameSite=Lax';
        return;
      }
      /* max-age acompanha o item que vence por ultimo: regravar o cookie nao
         pode estender a validade que o formulario deu. */
      var ultimo = itens.reduce(function (maior, i) {
        return Math.max(maior, Date.parse(i.expira) || 0);
      }, 0);
      var segundos = Math.max(0, Math.floor((ultimo - Date.now()) / 1000));
      document.cookie = COOKIE_BRINDE + '=' +
        encodeURIComponent(JSON.stringify({ itens: itens })) +
        '; path=/; max-age=' + segundos + '; SameSite=Lax';
    } catch (e) { /* cookie bloqueado: o brinde so nao aparece por aqui */ }
  }

  function tagsDaConta() {
    return ((CFG.cliente && CFG.cliente.tags) || []).map(normalizar);
  }

  function tagsDaCliente() {
    var tags = tagsDaConta();
    lerCookieBrinde().forEach(function (i) {
      var t = normalizar(i.tag);
      if (tags.indexOf(t) === -1) tags.push(t);
    });
    return tags;
  }

  function tagsClienteDaPromo(promo) {
    return ((promo.condicao && promo.condicao.regras) || [])
      .filter(function (r) { return r.tipo === 'tag_cliente'; })
      .map(function (r) { return normalizar(r.valor); });
  }

  /* >>> O COOKIE VALE UMA COMPRA <<<
     Quando o brinde da tag entra no carrinho, o item do cookie guarda o token
     desse carrinho. A Shopify troca o token quando o pedido e fechado - entao
     um token diferente do guardado quer dizer "aquela compra ja aconteceu" e
     o item sai. Um carrinho abandonado que expira tambem troca o token; nesse
     caso a conta ainda tem a tag e a integracao continua honrando pelo e-mail. */
  function expirarCookieUsado(carrinho) {
    var token = carrinho && carrinho.token ? String(carrinho.token) : '';
    if (!token) return;
    var itens = lerCookieBrinde();
    var restantes = itens.filter(function (i) {
      return !i.carrinho || i.carrinho === token;
    });
    if (restantes.length !== itens.length) gravarCookieBrinde(restantes);
  }

  function marcarCookieNoCarrinho(carrinho, brindes) {
    var token = carrinho && carrinho.token ? String(carrinho.token) : '';
    if (!token) return;
    var noCarrinho = {};
    brindes.forEach(function (b) {
      tagsClienteDaPromo(b.promo).forEach(function (t) { noCarrinho[t] = true; });
    });

    var mudou = false;
    var itens = lerCookieBrinde();
    itens.forEach(function (i) {
      var t = normalizar(i.tag);
      if (noCarrinho[t] && i.carrinho !== token) {
        i.carrinho = token;
        mudou = true;
      } else if (!noCarrinho[t] && i.carrinho === token) {
        delete i.carrinho;   // o brinde saiu deste carrinho: ainda nao foi usado
        mudou = true;
      }
    });
    if (mudou) gravarCookieBrinde(itens);
  }

  /* E-mail mascarado do formulario, para lembrar no carrinho qual usar no
     checkout. So quando a tag veio do cookie: na conta logada o e-mail ja e
     o da propria cliente. */
  function emailDoFormulario(promo) {
    var daConta = tagsDaConta();
    var tags = tagsClienteDaPromo(promo).filter(function (t) {
      return daConta.indexOf(t) === -1;
    });
    if (!tags.length) return '';
    var item = lerCookieBrinde().filter(function (i) {
      return tags.indexOf(normalizar(i.tag)) !== -1 && i.email;
    })[0];
    return item ? item.email : '';
  }

  /* meta e indexado pela posicao da linha em cart.items - o mesmo indice. */
  function algumaLinhaReal(carrinho, meta, teste) {
    var linhas = (carrinho && carrinho.items) || [];
    return linhas.some(function (item, indice) {
      if (eRecompensa(item)) return false;
      return teste(item, (meta && meta[indice]) || {});
    });
  }

  function avaliarRegra(regra, carrinho, meta) {
    var valor = regra.valor;

    switch (regra.tipo) {
      case 'quantidade_minima':
        return quantidadeReal(carrinho, meta) >= Number(valor || 0);

      /* O metacampo fala a lingua do lojista: REAIS. O /cart.js fala em
         centavos. A conversao mora aqui e so aqui. */
      case 'valor_minimo':
        return subtotalReal(carrinho) >= Math.round(Number(valor || 0) * 100);

      case 'tag':
        return algumaLinhaReal(carrinho, meta, function (item, m) {
          return (m.tags || []).indexOf(normalizar(valor)) !== -1;
        });

      case 'colecao':
        return algumaLinhaReal(carrinho, meta, function (item, m) {
          return (m.colecoes || []).indexOf(normalizar(valor)) !== -1;
        });

      /* Grupo montado em elegivel() quando a caixa colecoes_qualquer esta marcada. */
      case 'colecoes_qualquer':
        return regra.regras.some(function (r) { return avaliarRegra(r, carrinho, meta); });

      case 'produto':
        return algumaLinhaReal(carrinho, meta, function (item) {
          return normalizar(item.handle) === normalizar(valor);
        });

      case 'cupom':
        /* Valor reservado no metaobjeto: exige algum cupom real e reutiliza a
           verificacao de primeira compra do CELEBRE10 sem exigir esse codigo. */
        if (normalizar(valor) === CUPOM_PRIMEIRA_COMPRA) {
          return cuponsDoCarrinho(carrinho).length > 0 && candidataPrimeiraCompra();
        }
        return cuponsDoCarrinho(carrinho).indexOf(normalizar(valor)) !== -1;

      case 'tag_cliente':
        return tagsDaCliente().indexOf(normalizar(valor)) !== -1;

      default:
        console.warn('[theoric-promocoes] regra desconhecida: ' + regra.tipo +
          ' - a promocao foi tratada como NAO elegivel.');
        return false;
    }
  }

  function elegivel(promo, carrinho, meta) {
    var condicao = promo.condicao || {};
    var regras = condicao.regras || [];

    /* Sem regra nenhuma a promo vale para qualquer carrinho com item real.
       Carrinho vazio nunca premia - senao o brinde seria o unico item. */
    if (!regras.length) return quantidadeReal(carrinho, meta) > 0;
    if (quantidadeReal(carrinho, meta) === 0) return false;

    /* Cupom nunca disputa com os demais qualificadores dentro do
       condicao.operador: e sempre um AND, avaliado a parte. Sem essa
       separacao, "ou" soltaria a exigencia de cupom (o brinde sairia de
       graca) e "e" exigiria TODOS os qualificadores ao mesmo tempo, o que
       impede expressar "2 itens OU kit, mas sempre com cupom".
       tag_cliente segue a mesma logica: e quem pode receber, nao o que o
       carrinho precisa ter - um "ou" nunca pode dispensa-la. Entre si, as
       tags valem "qualquer uma" (o campo e "cliente com ALGUMA destas tags"):
       e o que permite trocar a tag de um formulario sem tirar o brinde de
       quem ja tinha a antiga. */
    function obrigatoria(r) { return r.tipo === 'cupom' || r.tipo === 'tag_cliente'; }
    var regrasCupom = regras.filter(function (r) { return r.tipo === 'cupom'; });
    var regrasTag = regras.filter(function (r) { return r.tipo === 'tag_cliente'; });
    var qualificadores = regras.filter(function (r) { return !obrigatoria(r); });

    if (regrasTag.length &&
        !regrasTag.some(function (r) { return avaliarRegra(r, carrinho, meta); })) {
      return false;
    }

    /* Caixa "basta qualquer uma das colecoes" (condicao_colecoes_qualquer):
       as regras de colecao deixam de ser soltas e viram UM qualificador que
       passa com qualquer colecao da lista. Sem a caixa, cada colecao conta
       sozinha e o "e" exige o carrinho em todas - foi o que zerou o Dia do
       Cliente de 15/09/2026 (6 colecoes, nenhum pedido cobria as seis). */
    if (condicao.colecoes_qualquer === true) {
      var regrasColecao = qualificadores.filter(function (r) { return r.tipo === 'colecao'; });
      if (regrasColecao.length) {
        qualificadores = qualificadores.filter(function (r) { return r.tipo !== 'colecao'; });
        qualificadores.push({ tipo: 'colecoes_qualquer', regras: regrasColecao });
      }
    }

    var cupomOk = regrasCupom.every(function (r) { return avaliarRegra(r, carrinho, meta); });
    if (!cupomOk) return false;
    if (!qualificadores.length) return true;

    var operador = normalizar(condicao.operador) === 'ou' ? 'ou' : 'e';

    return operador === 'ou'
      ? qualificadores.some(function (r) { return avaliarRegra(r, carrinho, meta); })
      : qualificadores.every(function (r) { return avaliarRegra(r, carrinho, meta); });
  }

  /* ======================================================================
     O QUE DEVERIA ESTAR NO CARRINHO
     ====================================================================== */

  /* Um brinde do tipo "brinde" nunca vira linha: ele nao precisa de variante,
     nem de produto publicado. As sacolas da Theoric, por exemplo, sao produtos
     em RASCUNHO - o all_products do Liquid nao os enxerga, e sem esta saida a
     promocao ficaria muda para sempre. Entao, quando o catalogo nao resolve o
     handle, o proprio metacampo descreve o presente. */
  function produtoAvulso(promo) {
    var premio = promo.premio || {};
    if (!premio.nome) return null;
    return {
      product_id: null,
      variant_id: null,
      titulo: premio.nome,
      imagem: premio.imagem || '',
      url: premio.url || '',
      disponivel: true,
      preco: 0
    };
  }

  function handleEscolhido(promo, carrinho) {
    var disponiveis = handlesDaPromo(promo);
    if (!disponiveis.length) return null;

    var escolhas = mapaDoAtributo(carrinho, ATRIBUTO_ESCOLHAS);
    var escolhido = escolhas[promo.id];
    if (escolhido && disponiveis.indexOf(escolhido) !== -1) return escolhido;

    /* Sem escolha registrada, o primeiro DISPONIVEL vira o padrao. Um premio
       esgotado que virasse padrao produziria uma linha que a Shopify recusa -
       e o cliente veria um erro no lugar de um presente. */
    for (var i = 0; i < disponiveis.length; i++) {
      var p = produtoDe(disponiveis[i]);
      if (p && p.disponivel) return disponiveis[i];
    }
    return null;
  }

  /* Uma promo nao automatica so entra quando o cliente aceita.

     >>> RECUSA IMPLICITA <<<
     Se o cliente remover a linha pelo botao normal do card, o aceite ficaria
     no atributo e o motor devolveria o item na hora seguinte - o carrinho
     brigaria com quem o usa. Por isso: uma vez que a linha existiu nesta
     sessao e depois sumiu sem que o motor a tirasse, o aceite e revogado. */
  function aceita(promo, carrinho) {
    if ((promo.premio || {}).automatico !== false) return true;

    var aceites = listaDoAtributo(carrinho, ATRIBUTO_OPTIN);
    if (aceites.indexOf(promo.id) === -1) return false;

    var temLinha = ((carrinho && carrinho.items) || []).some(function (item) {
      return promoDaLinha(item) === promo.id;
    });

    if (temLinha) {
      linhaJaVista[promo.id] = true;
      return true;
    }
    if (linhaJaVista[promo.id]) {
      linhaJaVista[promo.id] = false;
      return false;   // sumiu por mao do cliente: respeitar
    }
    return true;
  }

  function desejadas(promos, carrinho, meta) {
    var brindes = [];
    var diagnostico = [];

    /* Duas promocoes premiando o MESMO produto se anulam: a Shopify zera uma
       linha so, a segunda chega cobrada, o portao derruba as duas. Quando isso
       acontece, o certo e uma promocao com operador "ou" cobrindo as duas
       condicoes - e nao duas entradas no metacampo. Aqui, a primeira vence e a
       segunda e ignorada com aviso, para o carrinho nunca ficar inconsistente
       enquanto o cadastro nao e corrigido. */
    var premiadosVistos = {};

    promos.forEach(function (promo) {
      var apta = elegivel(promo, carrinho, meta);
      var handle = handleEscolhido(promo, carrinho);
      var produto = handle ? produtoDe(handle) : produtoAvulso(promo);
      var aceito = apta && aceita(promo, carrinho);

      if (apta && produto && produto.variant_id) {
        var chave = String(produto.variant_id);
        if (premiadosVistos[chave]) {
          console.warn('[theoric-promocoes] "' + promo.id + '" premia o mesmo ' +
            'produto que "' + premiadosVistos[chave] + '" e foi ignorada. Use ' +
            'UMA promocao com condicao.operador = "ou" no lugar de duas.');
          apta = false;
          aceito = false;
        } else {
          premiadosVistos[chave] = promo.id;
        }
      }

      diagnostico.push({
        id: promo.id,
        tipo: promo.tipo,
        titulo: promo.titulo || '',
        bloqueada: false,
        elegivel: apta,
        aceita: aceito,
        automatico: (promo.premio || {}).automatico !== false,
        opcoes: handlesDaPromo(promo),
        escolhido: handle,
        produto: produto
      });

      if (!apta || !aceito || !produto) return;

      brindes.push({
        promo: promo,
        handle: handle,
        produto: produto,
        quantidade: Number((promo.premio || {}).quantidade || 1) || 1
      });
    });

    ultimoEstado = { promocoes: diagnostico };
    return { brindes: brindes };
  }

  /* ======================================================================
     ESCRITA NO CARRINHO
     ====================================================================== */

  function mudarLinha(linha, quantidade) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: linha, quantity: quantidade })
    }).then(function (r) {
      return r.json().then(function (corpo) {
        if (!r.ok) {
          throw new Error(corpo.description || corpo.message ||
            'Nao foi possivel ajustar a linha da promocao.');
        }
        return corpo;
      });
    });
  }

  /* Remove de tras para frente: tirar a linha 2 faz a 3 virar 2. */
  function removerLinhas(carrinho, teste) {
    var linhas = [];
    ((carrinho && carrinho.items) || []).forEach(function (item, indice) {
      if (teste(item)) linhas.push(indice + 1);
    });
    if (!linhas.length) return Promise.resolve({ mudou: false, carrinho: carrinho });

    linhas.sort(function (a, b) { return b - a; });

    return linhas.reduce(function (p, linha) {
      return p.then(function (atual) {
        return mudarLinha(linha, 0).then(function (novo) { return novo || atual; });
      });
    }, Promise.resolve(carrinho)).then(function (novo) {
      return { mudou: true, carrinho: novo };
    });
  }

  function salvarAtributos(mudancas) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: mudancas })
    }).then(function (r) { return r.json(); });
  }

  /* Linhas _brinde=true podem ter sobrado do motor anterior. Elas sao sempre
     removidas: a bonificacao atual existe apenas no visual e no atributo que
     a integracao processa depois do pagamento. */
  function limparLinhasDeBrinde(carrinho) {
    return removerLinhas(carrinho, eRecompensa);
  }

  /* ======================================================================
     BRINDES - nunca linha, sempre atributo + card visual

     O atributo viaja no pedido (note_attributes) para a integracao incluir a
     bonificacao no ERP depois do pagamento.
     ====================================================================== */

  function serializarBrindes(brindes) {
    if (!brindes.length) return '';
    return JSON.stringify(brindes.map(function (b) {
      var omie = b.promo.omie || {};
      return {
        id: b.promo.id,
        nome: b.promo.titulo || b.produto.titulo,
        produto: b.produto.titulo,
        handle: b.handle,
        product_id: b.produto.product_id || null,
        variant_id: b.produto.variant_id || null,
        quantidade: b.quantidade,
        tipo: b.promo.tipo || 'bonificacao',
        rotulo: b.promo.rotulo || 'Gift Exclusivo THEORIC',
        codigo_produto: omie.codigo_produto || null,
        sku: omie.sku || '',
        cenario_impostos: omie.cenario_impostos || null,
        cfop: omie.cfop || '',
        integracao_erp: true,
        faturar: omie.faturar === true,
        /* Promo de tag: a integracao confere a tag no e-mail do pedido antes
           de faturar e a remove depois - e isso que a torna de uso unico. */
        tags_cliente: tagsClienteDaPromo(b.promo)
      };
    }));
  }

  function conciliarBrindes(carrinho, brindes) {
    var novo = serializarBrindes(brindes);
    var atual = atributos(carrinho)[ATRIBUTO_BRINDES] || '';

    if (novo === atual) return Promise.resolve({ mudou: false, carrinho: carrinho });

    var mudancas = {};
    mudancas[ATRIBUTO_BRINDES] = novo;
    return salvarAtributos(mudancas).then(function (c) {
      return { mudou: true, carrinho: c || carrinho };
    });
  }

  function pintarBrindes(brindes) {
    var alvos = document.querySelectorAll('[data-theoric-brindes]');
    if (!alvos.length) return;

    var html = brindes.map(function (b) {
      var promo = b.promo;
      var email = emailDoFormulario(promo);
      var imagem = b.produto.imagem
        ? '<img class="theoric-brinde__img" src="' + b.produto.imagem +
          '" alt="" loading="lazy" width="64" height="64">'
        : '';
      return '<li class="theoric-brinde" data-promo-id="' + escapar(promo.id) + '">' +
        imagem +
        '<div class="theoric-brinde__texto">' +
          '<span class="theoric-brinde__nome">' + escapar(b.produto.titulo) + '</span>' +
          '<span class="theoric-brinde__tag">' + escapar(
            promo.rotulo || 'Gift Exclusivo THEORIC'
          ) + '</span>' +
          (promo.mensagens && promo.mensagens.elegivel
            ? '<span class="theoric-brinde__nota">' + escapar(promo.mensagens.elegivel) + '</span>'
            : '') +
          (email
            ? '<span class="theoric-brinde__nota">Finalize com o e-mail ' + escapar(email) +
              ' para receber o brinde.</span>'
            : '') +
        '</div>' +
      '</li>';
    }).join('');

    Array.prototype.forEach.call(alvos, function (alvo) {
      alvo.innerHTML = html ? '<ul class="theoric-brinde__lista">' + html + '</ul>' : '';
      alvo.hidden = !html;
    });
  }

  function escapar(txt) {
    var d = document.createElement('div');
    d.textContent = txt == null ? '' : txt;
    return d.innerHTML;
  }

  /* ======================================================================
     CONCILIACAO
     ====================================================================== */

  function publicar(carrinho) {
    T.sincronizar(true);
    T.atualizarBolinha();

    if (typeof publish === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'theoric-promocoes',
        cartData: carrinho
      });
    }
  }

  function reconciliar(carrinho) {
    if (processando || !carrinho || !carrinho.items) return;

    var promos = promosAtivas();
    expirarCookieUsado(carrinho);

    /* Sem promocao ativa ainda ha trabalho: limpar recompensas que sobraram de
       uma campanha encerrada. Um brinde de promocao morta e um prejuizo. */
    processando = true;

    var pedirMeta = precisaDeMeta(promos)
      ? buscarMeta(carrinho).catch(function (e) {
          console.warn('[theoric-promocoes] metadados indisponiveis; regras de ' +
            'quantidade/tag/colecao foram ignoradas nesta passagem.', e);
          return null;
        })
      : Promise.resolve(null);

    pedirMeta
      .then(function (meta) {
        var alvos = desejadas(promos, carrinho, meta);
        marcarCookieNoCarrinho(carrinho, alvos.brindes);
        return limparLinhasDeBrinde(carrinho)
          .then(function (r) {
            return conciliarBrindes(r.carrinho, alvos.brindes)
              .then(function (r2) {
                pintarBrindes(alvos.brindes);
                return { mudou: r.mudou || r2.mudou, carrinho: r2.carrinho };
              });
          });
      })
      .then(function (r) {
        if (r && r.mudou) publicar(r.carrinho);
      })
      .catch(function (e) {
        console.error('[theoric-promocoes] falha ao conciliar as promocoes.', e);
        T.sincronizar(true);
      })
      .finally(function () {
        processando = false;
      });
  }

  /* ======================================================================
     API PUBLICA
     ====================================================================== */

  function atualizarLista(chave, id, incluir) {
    var carrinho = T.estado();
    var lista = listaDoAtributo(carrinho, chave).filter(function (v) {
      return v !== id;
    });
    if (incluir) lista.push(id);

    var mudancas = {};
    mudancas[chave] = lista.join(',');
    return salvarAtributos(mudancas).then(function (c) {
      reconciliar(c);
      return c;
    });
  }

  window.TheoricPromos = {
    estado: function () { return ultimoEstado; },

    adicionar: function (id) {
      linhaJaVista[id] = false;
      return atualizarLista(ATRIBUTO_OPTIN, id, true);
    },

    remover: function (id) {
      linhaJaVista[id] = false;
      var carrinho = T.estado();
      return removerLinhas(carrinho, function (item) {
        return promoDaLinha(item) === id;
      }).then(function () {
        return atualizarLista(ATRIBUTO_OPTIN, id, false);
      });
    },

    escolher: function (id, handle) {
      var carrinho = T.estado();
      var escolhas = mapaDoAtributo(carrinho, ATRIBUTO_ESCOLHAS);
      escolhas[id] = handle;

      var serializado = Object.keys(escolhas).map(function (k) {
        return k + ':' + escolhas[k];
      }).join(',');

      var mudancas = {};
      mudancas[ATRIBUTO_ESCOLHAS] = serializado;
      return salvarAtributos(mudancas).then(function (c) {
        reconciliar(c);
        return c;
      });
    },

    reconciliar: reconciliar
  };

  T.ao(reconciliar);
})();
